import { useQuery } from '@tanstack/react-query';
import groq from 'groq';
import { PRODUCT_SLUG } from 'lib/queries';
import { client } from 'lib/sanity';
import type { ProductSlug } from 'types/cms/ProductSlug';
import type { SiteCategory } from 'types/common/SiteCategory';

export const SANITY_PRODUCT_SLUGS_KEY = 'sanityProductSlugs';

export type ProductSlugsQueryKey = [string, SiteCategory];

export const fetchSanityProductSlugs = async (
  siteCategory: SiteCategory,
): Promise<ProductSlug[]> => {
  const query = groq`
    *[_type == "product" && !(_id in path('drafts.**')) && store.status != "archived" && store.isDeleted == false && store.status == "active" && category == $siteCategory] {
      ${PRODUCT_SLUG}
    }
  `;

  const productSlugs: ProductSlug[] = await client.fetch(query, {
    siteCategory,
  });

  return productSlugs;
};

export const useSanityProductSlugs = (
  siteCategory: SiteCategory,
  enabled = true,
) =>
  useQuery({
    queryKey: [SANITY_PRODUCT_SLUGS_KEY, siteCategory],
    queryFn: () => fetchSanityProductSlugs(siteCategory),
    enabled,
  });
